if (!customElements.get("image-with-dropdown")) {
  class ImageWithDropdown extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector("[data-dropdown-toggle]");
      this.panel = this.querySelector("[data-dropdown-content]");

      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener("click", this.handleToggle.bind(this));
    }

    handleToggle(event) {
      event.preventDefault();
      const isOpen = this.toggle.getAttribute("aria-expanded") === "true";
      this.setOpen(!isOpen);
    }

    setOpen(open) {
      this.toggle.setAttribute("aria-expanded", String(open));
      this.panel.setAttribute("data-open", String(open));
    }
  }

  customElements.define("image-with-dropdown", ImageWithDropdown);
}
